import React from 'react'

interface CardProps {
  id: string
  header?: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
  className?: string
  hoverEffect?: boolean
}

const Card: React.FC<CardProps> = ({ id, header, children, footer, className = '', hoverEffect = false }) => (
  <div
    id={id}
    className={`bg-white rounded-[16px] w-full ${className}
          ${hoverEffect ? 'hover:shadow-lg transition-shadow duration-300' : ''}`}
  >
    {header && <div className="mb-4">{header}</div>}
    {children}
    {footer && <div className="mt-4">{footer}</div>}
  </div>
)

export default Card
